module.exports = __webpack_public_path__ + "img/work-plans.95be859b.svg";